module.exports = __webpack_public_path__ + "img/icon_print.6c2f49d4.png";